<template>
  <div v-if="$userInfo.isSystemAdministrator">
    <app-detail-header :show-toggle="true"
      :show-new="true"
      :show-delete="false"
      :show-save="false"
      :show-print="false"
      :show-cancel="false"
      @appDetailHeaderButtonClicked="onHeaderButtonClicked" />
    <div class="columns is-gapless">
      <div class="column is-narrow">
        <flexiquote-module-list-side-menu v-model="filter"
          @filter="filterList"
          @reset="resetList" />
      </div>
      <div class="column">
        <div class="m-3">
          <article class="box">
            <bulma-table class="table is-bordered is-striped is-narrow is-fullwidth"
              :columns="columns"
              :page-index="filter.pageIndex"
              :page-size="filter.pageSize"
              :total-rows="totalRows"
              :is-loading="isTableLoading"
              :sort-column="filter.sortColumn"
              :sort-order="filter.sortOrder"
              @pageChanged="onPageChange"
              @sort="sort">
              <tr v-for="(entity, index) in entitySummaries"
                :key="entity.flexiQuoteModuleId"
                :class="{ 'is-selected' : selectedRow === index }"
                @click="highlightSelected(index, $event)">
                <td>
                  <router-link :to="{ path: `/superadmin/flexiquotemodule/${entity.flexiQuoteModuleId}` }">
                    {{ entity.modDesc }}
                  </router-link>
                </td>
                <td class="has-text-centered">
                  <span class="icon"
                    :class="[ entity.isBase ? 'has-text-success' : 'has-text-danger' ]">
                    <span class="mso mso-24px">
                      {{ entity.isBase ? 'check' : 'close' }}
                    </span>
                  </span>
                </td>
              </tr>
              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <span icon="icon is-large">
                      <span class="mso mso-fill mso-40px">sentiment_dissatisfied</span>
                    </span>
                    <p>Nothing</p>
                  </div>
                </section>
              </template>
            </bulma-table>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppDetailHeader from '@/components/AppDetailHeader'
import FlexiquoteModuleListSideMenu from './FlexiquoteModuleListSideMenu'
import FlexiquoteModuleService from './flexiquoteModuleService'
import BulmaTable from '@/components/BulmaTable'
import { Columns } from './columns'
import { AppHeaderButtonTypes } from '@/enums'
import StoreMixin from './storeMixin'

export default {
  name: 'FlexiquoteModuleListView',
  components: {
    AppDetailHeader,
    BulmaTable,
    FlexiquoteModuleListSideMenu
  },
  mixins: [StoreMixin],
  props: {},
  data: () => {
    return {
      entitySummaries: {},
      totalRows: 0,
      filter: {
        moduleDescription: '',
        sortColumn: Columns[0].name,
        sortOrder: Columns[0].defaultOrder,
        pageIndex: 1,
        pageSize: 18
      },
      selectedRow: null,
      isTableLoading: false
    }
  },
  computed: {
    columns() {
      return Columns
    },
    filterKey() {
      return 'flexiquotemodule-list-filter'
    }
  },
  watch: {},
  created() {
    this.getData()
  },
  mounted() {},
  destroyed() {},
  beforeDestroy() {},
  methods: {
    onHeaderButtonClicked(action) {
      switch (action) {
        case AppHeaderButtonTypes.AddNew:
          this.addNew()
          break
        case AppHeaderButtonTypes.Print:
          break
        case AppHeaderButtonTypes.Delete:
          break
        case AppHeaderButtonTypes.Save:
          break
        case AppHeaderButtonTypes.Cancel:
          break
      }
    },
    filterList() {
      this.filter.pageIndex = 1
      this.persistFilter()
      this.getData()
    },
    sort(name, order) {
      this.filter.sortColumn = name
      this.filter.sortOrder = order
      this.persistFilter()
      this.getData()
    },
    resetList() {
      this.filter.moduleDescription = ''
      this.filter.sortColumn = Columns[0].name
      this.filter.sortOrder = Columns[0].defaultOrder
      this.filter.pageIndex = 1
      this.filter.pageSize = 18
      this.persistFilter()
      this.getData()
    },
    persistFilter() {
      sessionStorage.setItem(this.filterKey, JSON.stringify(this.filter))
    },
    retrieveFilter() {
      const filter = JSON.parse(sessionStorage.getItem(this.filterKey))
      if (filter) {
        this.filter = filter
      }
    },
    onPageChange(pageIndex) {
      this.filter.pageIndex = pageIndex
      this.persistFilter()
      this.getData()
    },
    async getData() {
      this.isTableLoading = true
      this.retrieveFilter()
      this.entitySummaries = await FlexiquoteModuleService.getFlexiquoteModules(this.filter)
      this.totalRows = this.entitySummaries.length > 0 ? this.entitySummaries[0].totalRows : 0
      this.isTableLoading = false
    },
    highlightSelected(index, event) {
      this.selectedRow = index
    },
    async addNew() {
      await this.addStoreItem()
    }
  }
}
</script>

